import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { LockedFeature } from '../models/epi-model';
import { LockedPageKeys, LockedPageState, LocksModel } from '../models/locked-page-model';

export const useLockedPageState = (key: LockedPageKeys): LockedPageState => {

    // we should be getting locks from employment when possible. Fallback on employee locks
    const locks = useSelector<TcsmStates, LocksModel>(state => state.employmentState?.currentEmployment?.locks || state.employmentState?.currentEmployee?.locks);

    const lockedFeatureMapping = useSelector<TcsmStates, LockedFeature>(state => state.epiProps?.siteSettingsState?.siteSettings?.lockedPagesMessaging
        ?.find(x => x.locksKey === key));

    
    const getLockedSummaries = () => {
        if (!locks[key]) return null;

        const mappedReasons = [];

        for (let i = 0; i < locks[key]?.length; i += 1) {
            const reasonKey = locks[key][i];

            const mappedReason = lockedFeatureMapping?.lockedReasonMessages?.find(x => x.lockedReasonKey === reasonKey);

            // add mapped message if it exists, otherwise add the key
            mappedReasons.push(mappedReason?.lockedReasonSummary || reasonKey);
        }

        return mappedReasons;
    };

    return useMemo(() => {
        const defaultState: LockedPageState = {
            isLocked: false,
        };

        if (!key || !locks) {
            return defaultState;
        }

        if (locks[key]?.length > 0) {
            return {
                isLocked: true,
                generalMessage: lockedFeatureMapping?.generalMessage || 'This feature is locked for the following reasons:',
                lockedSummaries: getLockedSummaries(),

            };
        }

        return defaultState;

    }, [key, locks]);   
};